import { useMemo } from "react";
import type { SortState } from "./useSortState";

export function useSortedItems<TItem, TColumn extends string>(
  items: readonly TItem[],
  sortState: SortState<TColumn>,
  compare: (a: TItem, b: TItem, column: TColumn) => number,
): TItem[] {
  return useMemo(() => {
    const sign = sortState.direction === "asc" ? 1 : -1;
    return [...items].sort((a, b) => sign * compare(a, b, sortState.column));
  }, [items, sortState, compare]);
}
